import { Component, OnInit, OnDestroy } from '@angular/core';
import { ServiceService, Server, Service, APIManager, NotificationService, AFTER_INVOICE_PAID } from '@flashvpn-io/web-core';
import { StatusService, ConnectionStatus } from '../../services/status.service';
import { Subscription } from 'rxjs';
import { Router } from '@angular/router';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit, OnDestroy {
  public servers: Server[] = [{
    id: 1,
    localId: '1',
    serviceId: 1,
    name: 'DEFAULT SERVER',
    host: '127.0.0.1',
    port: 8080,
    status: 1,
    country: 'Hong Kong',
    description: 'Hong Kong Default Server',
    type: 'VIP2',
    probe: 'ping',
    tags: ['Hong Kong', 'VIP2'],
    username: 'test',
    password: 'test',
    uuid: 'test',
    latency: '100ms',
    ping: () => 100
  }];


  public connectionStatus: ConnectionStatus = 'disconnected';
  public mode: 'global' | 'rules' = 'global';
  public currentServer: Server | null = null;
  public noService: boolean = false;
  public loading: boolean = true;

  private connectionStatusSubscription: Subscription = new Subscription();
  private modeSubscription: Subscription = new Subscription();
  private serverSubscription: Subscription = new Subscription();
  private currentServerSubscription: Subscription = new Subscription();
  private serviceSubscription: Subscription = new Subscription();
  public service: Service = new Service('', '', '', '', 0, '', { allowed: 0, download: 0, upload: 0 }, '', 0);

  constructor(
    private serviceService: ServiceService,
    private statusService: StatusService,
    private apiManager: APIManager,
    private router: Router,
    private notificationService: NotificationService,
  ) {
    this.connectionStatus = this.statusService.getCurrentConnectionStatus();
    this.mode = this.statusService.getCurrentMode();
    this.currentServer = this.statusService.getCurrentSelectedServer();
    this.notificationService.register(AFTER_INVOICE_PAID).subscribe(() => {
      this.serviceService.refreshServiceInfo();
    });
  }

  ngOnInit(): void {
    this.init();
  }

  changeMode(): void {
    const mode = this.mode === 'global' ? 'rules' : 'global';
    this.statusService.setMode(mode);
  }

  async init() {
    this.loading = true;
    this.connectionStatusSubscription = this.statusService.getConnectionStatus().subscribe(status => {
      this.connectionStatus = status;
      console.log('connectionStatusUpdated', this.connectionStatus);
    });
    this.modeSubscription = this.statusService.getMode().subscribe(mode => {
      console.log('modeUpdated', mode);
      this.mode = mode;
    });
    this.currentServerSubscription = this.statusService.getSelectedServer().subscribe(server => {
      this.currentServer = server;
    });

    const data = this.statusService.getServersFromLocalStorage();
    if (data) {
      this.servers = data;
    }

    this.serviceService.currentService$.subscribe({
      next: (service) => {
        this.loading = false;
        if (service) {
          this.noService = false;
          this.service = service;
          this.statusService.setService(service);
          this.serverSubscription = this.apiManager.fetchServers(service).subscribe({
            next: (servers) => {
              if (servers && servers.length > 0) {
                this.servers = servers;
                this.statusService.setServers(servers);

                if (!this.currentServer) {
                  this.statusService.setCurrentServer(servers[0]);
                }
              } else {
                console.log('从网络获取服务器列表为空，继续使用缓存数据');
              }
            },
            error: (error) => {
              console.error('获取服务器列表失败，使用缓存数据', error);
            }
          });
        } else {
          this.noService = true;
        }
      },
      error: (error) => {
        this.loading = false;
        this.noService = true;
        console.error('Error getting service:', error);
      }
    });
  }

  showServers() {
    this.router.navigate(['/servers']);
  }

  refreshServerList(): void {
    // 先使用缓存数据
    const cachedServers = this.statusService.getServersFromLocalStorage();
    if (cachedServers && cachedServers.length > 0) {
      this.servers = cachedServers;
    }

    // 尝试从网络获取最新数据
    this.serviceService.currentService$.subscribe({
      next: (service) => {
        if (service) {
          this.service = service;
          this.apiManager.fetchServers(service).subscribe({
            next: (servers) => {
              if (servers && servers.length > 0) {
                console.log('刷新成功：从网络获取服务器列表', servers);
                this.servers = servers;
                this.statusService.setServers(servers);
              } else {
                console.log('刷新结果：网络返回空数据，继续使用缓存');
              }
            },
            error: (error) => {
              console.error('刷新失败：获取服务器列表出错，使用缓存数据', error);
            }
          });
        }
      },
      error: (error) => {
        console.error('刷新失败：获取服务信息出错', error);
      }
    });
  }

  ngOnDestroy(): void {
    if (this.connectionStatusSubscription) {
      this.connectionStatusSubscription.unsubscribe();
    }
    if (this.modeSubscription) {
      this.modeSubscription.unsubscribe();
    }
    if (this.serverSubscription) {
      this.serverSubscription.unsubscribe();
    }
    if (this.currentServerSubscription) {
      this.currentServerSubscription.unsubscribe();
    }
  }
}
